<template>
  <div class="jbotportal">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">JBot Portal(RPA)</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-img contain :src="require('@/assets/img_sub_prod_jbotportal.svg')" max-height="344"></v-img>
          <v-row class="align-stretch mt-8">
            <v-col cols="12" class="d-flex align-stretch">

              <v-card width="100%" class="px-4 pt-8 pb-10" outlined>
                <v-row class="align-stretch">
                  <v-col cols="12" sm="6">
                    <h5 class="text-h6 text-md-h5 font-weight-bold">JBot Portal 소개</h5>
                    <ul class="list-type02 mt-2">
                      <li>Bot 개발, 현황, 개발 표준문서/매뉴얼, 즉시/스케줄링 실행, 상태 모니터링, 장애관리 등 RPA Bot 개발 및 운영에 필요한 관리 메뉴를 제공 합니다.</li>
                    </ul>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h5 class="text-h6 text-md-h5 font-weight-bold">JBot Portal 특징</h5>
                    <ul class="list-type02 mt-2">
                      <li>RPA Bot 모니터링을 통하여 실행 상태 확인 및 신속한 장애처리</li>
                      <li>RPA Bot 실행 편의성 제공(JBot Portal 사용자 실행)</li>
                      <li>RPA 개발 요청 및 결재 승인에 의한 개발 현황 관리</li>
                      <li>RPA 개발 표준 및 규정/매뉴얼 문서 자료 관리</li>
                      <li>사용자별 JBot Portal 메뉴 권한 관리</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
          <v-row class="mt-16 justify-center">
            <v-btn outlined x-large href="https://www.jbot.co.kr/" target="_blank">JBot Portal</v-btn>
          </v-row>

        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'jbotportal',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".jbotportal .sub-body-title", {
      scrollTrigger: {
        trigger: ".jbotportal .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".jbotportal .sub-body-content", {
      scrollTrigger: {
        trigger: ".jbotportal .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>